import { Promise } from '../../../lib';
var KEEPALIVE_REQUEST_SUPPORTED = typeof window !== 'undefined' &&
    'fetch' in window &&
    typeof Request !== 'undefined' &&
    'keepalive' in new Request('https://www.xing.com');
var isKeepaliveRequestSupported = function () {
    return KEEPALIVE_REQUEST_SUPPORTED;
};
/**
 * Sends data to a specified URL using the Fetch API with keepalive enabled.
 * The keepalive option ensures that the request continues even if the page is unloaded.
 *
 * @param {string} url - The endpoint URL to send the request to
 * @param {object} payload - The data to be sent in the request body (will be JSON-stringified)
 * @returns {Promise<unknown>} A promise that resolves when the request succeeds or rejects with an error
 * @throws {Error} If the fetch request fails or if there's an error during execution
 */
var sendKeepaliveFetch = function (url, payload) {
    return new Promise(function (resolve, reject) {
        try {
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'text/plain',
                },
                credentials: 'include',
                keepalive: true,
                body: JSON.stringify(payload),
            })
                .then(function (args) { return resolve(args); })
                .catch(function () {
                return reject(new Error("Wasn't able to send data with keepalive fetch"));
            });
        }
        catch (error) {
            reject(error);
        }
    });
};
export default sendKeepaliveFetch;
export { isKeepaliveRequestSupported };
